import React from "react"

export const DropdownChevron = ({ colour }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="12"
      height="8"
      viewBox="0 0 12 8"
      fill="none"
    >
      <path
        d="M11.8336 2.17208L6.4037 7.68067C6.18178 7.90561 5.82294 7.90561
      5.5963 7.68546L0.166437 2.17687C-0.055479 1.95193 -0.055479 1.5882 0.166437
      1.36327L0.501673 1.02347C0.723589 0.798527 1.08243 0.798527 1.30435 1.02347L6.00236
      5.78545L10.6957 1.01868C10.9176 0.793741 11.2764 0.793741 11.4983 1.01868L11.8336
      1.35848C12.0555 1.58342 12.0555 1.94715 11.8336 2.17208Z"
        fill={!colour ? "#051C2C" : colour}
      />
    </svg>
  )
}
